export default "__VITE_ASSET__e50f92d2__"